import { useEffect, useState } from 'react';
import { navItems } from '@/mocks/home';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div
        className={`hidden md:block border-b transition-colors duration-300 ${
          scrolled ? 'border-background-200' : 'border-background-50/20'
        }`}
      >
        <div className="mx-auto max-w-[1360px] px-6 lg:px-10 h-9 flex items-center justify-between text-xs">
          <p className={scrolled ? 'text-foreground-500' : 'text-background-50/85'}>
            线索投稿邮箱：tips@18baoliao.example · 每条爆料都标注来源与校验状态
          </p>
          <div className={`flex items-center gap-5 ${scrolled ? 'text-foreground-500' : 'text-background-50/85'}`}>
            <span className="flex items-center gap-1.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shield-check-line text-[13px]" />
              </span>
              实锤证据持续补充
            </span>
            <a href="#subscribe" className="hover:opacity-80 transition-opacity whitespace-nowrap">
              线索投稿
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10">
        <div className="h-16 md:h-[74px] flex items-center justify-between gap-6">
          <a href="#top" className="flex items-center gap-2.5 shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
              18
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading font-bold text-xl tracking-tight ${
                  scrolled ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                18爆料网
              </span>
              <span
                className={`text-[10px] tracking-[0.22em] mt-1 ${
                  scrolled ? 'text-foreground-400' : 'text-background-50/70'
                }`}
              >
                EXPOSE · ARCHIVE
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-3.5 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <div
              className={`hidden md:flex items-center gap-2 h-10 px-3.5 rounded-md border transition-colors ${
                scrolled ? 'border-background-300 bg-background-100' : 'border-background-50/30 bg-background-50/10'
              }`}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`ri-search-line text-sm ${scrolled ? 'text-foreground-400' : 'text-background-50/80'}`} />
              </span>
              <input
                type="text"
                placeholder="搜事件 / 关键词"
                className={`bg-transparent outline-none text-sm w-32 xl:w-40 ${
                  scrolled
                    ? 'text-foreground-900 placeholder:text-foreground-400'
                    : 'text-background-50 placeholder:text-background-50/60'
                }`}
              />
            </div>

            <a
              href="#subscribe"
              className="hidden sm:flex items-center gap-1.5 h-10 px-4 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-2-line text-base" />
              </span>
              下载 App
            </a>

            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md border ${
                scrolled ? 'border-background-300 text-foreground-800' : 'border-background-50/30 text-background-50'
              }`}
            >
              <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <nav className="mx-auto max-w-[1360px] px-4 py-3 flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="py-3 px-2 text-sm text-foreground-800 border-b border-background-100 last:border-0 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-3 flex items-center justify-center gap-1.5 h-11 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-download-2-line text-base" />
              </span>
              下载 App
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}